var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGasTransmission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40204 9.40202 0 21 0C32.598 0 42 9.40204 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z",
    fill: "#EDFEF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7966 14.0776L20.4066 13.7176C20.2947 13.6032 20.1492 13.5277 19.9913 13.502C19.8334 13.4762 19.6714 13.5017 19.529 13.5745C19.3866 13.6474 19.2712 13.7639 19.1997 13.9071C19.1282 14.0502 19.1044 14.2124 19.1316 14.3701C19.2481 15.542 19.0131 16.7221 18.4566 17.7601C18.1098 18.3768 17.7055 18.9593 17.2491 19.5001C16.3052 20.5232 15.7712 21.8582 15.7491 23.2501C15.7348 23.9434 15.8609 24.6325 16.1196 25.276C16.3784 25.9194 16.7646 26.5038 17.255 26.9942C17.7454 27.4846 18.3298 27.8708 18.9733 28.1296C19.6167 28.3884 20.3058 28.5144 20.9991 28.5001C21.6925 28.5144 22.3816 28.3884 23.025 28.1296C23.6684 27.8708 24.2529 27.4846 24.7433 26.9942C25.2337 26.5038 25.6199 25.9194 25.8786 25.276C26.1374 24.6325 26.2634 23.9434 26.2491 23.2501C26.2491 18.9451 22.2891 15.4051 20.7966 14.0776ZM20.9991 27.0001C20.6371 27.0097 20.2805 26.9113 19.9746 26.7174C19.6688 26.5235 19.4277 26.2428 19.282 25.9113C19.1363 25.5797 19.0928 25.2123 19.1568 24.8559C19.2209 24.4994 19.3897 24.1702 19.6416 23.9101C19.8002 23.7233 19.9292 23.5134 20.0241 23.2876C20.1546 22.9129 20.2303 22.5214 20.2491 22.1251C20.2495 22.051 20.2718 21.9788 20.3132 21.9174C20.3545 21.856 20.4132 21.8082 20.4816 21.7801C20.5492 21.7494 20.6248 21.7409 20.6975 21.7557C20.7702 21.7705 20.8364 21.8079 20.8866 21.8626L21.0141 21.9751C21.5241 22.4251 22.8741 23.6326 22.8741 25.1251C22.8792 25.3727 22.8342 25.6188 22.7418 25.8486C22.6494 26.0784 22.5115 26.2871 22.3363 26.4623C22.1612 26.6374 21.9525 26.7753 21.7227 26.8678C21.4929 26.9602 21.2468 27.0052 20.9991 27.0001Z",
    fill: "#00A852"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasTransmission);
export default __webpack_public_path__ + "static/media/gas_transmission.68adf776b775d572f93a1cf6c9f155a2.svg";
export { ForwardRef as ReactComponent };